import {GalleryData} from "./GalleryData";

import batmen1 from "../../assets/img/photo/batmen/batmen-5.jpg";
import chalengParty1 from "../../assets/img/photo/challenge-party/chalenge-party-4.jpg";
import denRozdenia from "../../assets/img/photo/den-rozdenia/den-rozdenia-2.jpg";
import dino from "../../assets/img/photo/dino/dino-paty-1.jpg";
import frostymagic1 from "../../assets/img/photo/frosty-magic/forstymagic-5.jpg";
import pirate1 from  "../../assets/img/photo/pirate-paty/pirate-1.jpg"




export const GallerySlide = (): GalleryData[] => [
    {
        img: batmen1,
        alt: "Бэтмен"
    },
    {
        img: chalengParty1,
        alt: "Пижамная вечеринка"
    },
    {
        img: denRozdenia,
        alt: "День рождения"
    },
    {
        img: dino,
        alt: "Дино"
    },
    {
        img: frostymagic1,
        alt: "Морозное волшебство"
    },
    {
        img: pirate1,
        alt: "Пиратская вечеринка"
    },

]